import { Timestamp } from 'firebase/firestore';
import { IArtisan } from '@core/interfaces/IArtisan';
import { IDocumentDataArtisan } from '../interfaces/IDocumentDataArtisan';

export const transformDataToArtisan = ({
    creationDate,
    lastConnection,
    lastPortfolioUpdateDate,
    subscriptionDate,
    subscriptionExpirationDate,
    ...rest
}:IDocumentDataArtisan):IArtisan => ({
    ...rest,
    ...(creationDate && {
        creationDate: creationDate.toDate(),
    }),
    ...(lastConnection && {
        lastConnection: lastConnection.toDate(),
    }),
    ...(lastPortfolioUpdateDate && {
        lastPortfolioUpdateDate: lastPortfolioUpdateDate.toDate(),
    }),
    ...(subscriptionDate && {
        subscriptionDate: subscriptionDate.toDate(),
    }),
    ...(subscriptionExpirationDate && {
        subscriptionExpirationDate: subscriptionExpirationDate.toDate(),
    }),
});

export const transformArtisanToData = ({
    creationDate,
    lastConnection,
    lastPortfolioUpdateDate,
    subscriptionDate,
    subscriptionExpirationDate,
    ...rest
}:IArtisan):IDocumentDataArtisan => ({
    ...rest,
    ...(creationDate && {
        creationDate: Timestamp.fromDate(creationDate),
    }),
    ...(lastConnection && {
        lastConnection: Timestamp.fromDate(lastConnection),
    }),
    ...(lastPortfolioUpdateDate && {
        lastPortfolioUpdateDate: Timestamp.fromDate(lastPortfolioUpdateDate),
    }),
    ...(subscriptionDate && {
        subscriptionDate: Timestamp.fromDate(subscriptionDate),
    }),
    ...(subscriptionExpirationDate && {
        subscriptionExpirationDate: Timestamp.fromDate(subscriptionExpirationDate),
    }),
});
